export default "__VITE_ASSET__7pNQndCF__"